var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TableCustomerList',{attrs:{"form":_vm.form,"fields":_vm.fields,"items":_vm.items,"isBusy":_vm.isBusy,"filter":_vm.filter,"rows":_vm.rows,"pageOptions":_vm.pageOptions,"showing":_vm.showing,"showingTo":_vm.showingTo},on:{"getPage":_vm.getPage,"getPageOption":_vm.getPageOption}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }